export default __webpack_public_path__ + "static/media/advicegradissuegfx-11.617d5558.png";